import { siteCall } from "../utils/WebCall";
import urls from '../utils/urls'
import { LIMIT } from '../../src/config/Constants'
import { getCurrentUser } from "./UserService"

export const createUserBotMeetings = async(user_id, params, successCallback, errorCallback) => {
  return siteCall({
      url: urls.user_bot_meetings_url + "/create",
      method: "POST",
      body: JSON.stringify(params),
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const updateUserBotMeetings = async(user_id, bot_meeting_id, params, successCallback, errorCallback) => {
    return siteCall({
        url: urls.user_bot_meetings_url + "/update/" + bot_meeting_id,
        method: "PUT",
        body: JSON.stringify(params),
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
}


export const partialUpdateUserBotMeetings = async(user_id, bot_meeting_id, params, successCallback, errorCallback) => {
  return siteCall({
      url: urls.user_bot_meetings_url + "/partial-update/" + bot_meeting_id,
      method: "PATCH",
      body: JSON.stringify(params),
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const getUserBotMeetings = async(user_id, bot_meeting_id, successCallback, errorCallback) => {
  return siteCall({
      url: urls.user_bot_meetings_url + "/get/" + bot_meeting_id,
      method: "GET",
      body: {},
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}

export const deleteUserBotMeetings = async(user_id, bot_meeting_id, successCallback, errorCallback) => {
  return siteCall({
      url: urls.user_bot_meetings_url + "/delete/" + bot_meeting_id,
      method: "DELETE",
      body: {},
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}

export const getAllUserBotMeetings = async(user_id, params, successCallback, errorCallback) => {
  return siteCall({
      url: urls.user_bot_meetings_url + `/get-all`,
      method: "POST",
      body: JSON.stringify(params),
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const fetchBotMeetings = async (dispatch, page, limit) => {
  page = page || 0;
  limit = limit || LIMIT;
  let user = getCurrentUser();
  return await getAllUserBotMeetings(user.uid, { "order_by": "createdAt", "order": "desc", "page": page, "limit": limit },
    (response) => {
      let data = response.data;
      let records = data.records;
      import("../redux/actions/meetingsActions").then((ac) =>
        dispatch(ac.setMeetings(records))
      );
      return data;
    },
    (error) => {
        console.log("error: ", error);
        return [];
    }
  )
};